import { z } from "zod";
import { INVALID_EMAIL, REQUIRED_FIELD } from "../../../utils/constants";

export const AccountItemSchema = z.object({
  name: z.string().min(1, { message: REQUIRED_FIELD }),
  email: z
    .string()
    .min(1, { message: REQUIRED_FIELD })
    .refine((value) => !value || z.string().email().safeParse(value).success, {
      message: INVALID_EMAIL,
    }),
});
